'use client';

import { useTranslation } from 'next-i18next';
import { Button, Tooltip } from '@components/common';
import { ShareIcon } from '@heroicons/react/20/solid';
import { ShareModal } from '@components/features/modals/share-modal/ShareModal';
import { useBjModal } from '@hooks/common/useBjModal';

// Interface
// ************************************
interface EmployerShareProps {
  employerName: string;
}

/**
 * @description Renders a share button and a modal for sharing the employer's profile page.
 *
 * - **employerName** - string. The name of the employer.
 */
export const EmployerShare = (props: EmployerShareProps) => {
  // Destructure props
  const { employerName } = props;

  // Translation
  const { t } = useTranslation('common');

  // States for Share Modal
  const { isOpen: isOpenShareModal, toggleModal: toggleShareModal } = useBjModal();

  return (
    <>
      {/* Share job modal button */}
      <Tooltip
        tooltipText={t('job.detail.share.modal.title')}
        position="top"
        colorScheme="black"
      >
        <Button
          size="sm"
          rounding="full"
          className="ml-2 !border-transparent !p-2 !text-primary"
          styling="outline"
          color="light"
          onClick={toggleShareModal}
        >
          <ShareIcon className="size-5" />
        </Button>
      </Tooltip>

      {/* Share modal */}
      <ShareModal
        isOpen={isOpenShareModal}
        onClose={toggleShareModal}
        copyLinkText={t('company.detail.share.modal.subtitle')}
        ogTitle={employerName}
        ogDescription=""
      />
    </>
  );
};
